import { isIOSLikeSafariBrowser } from '~/utils';

// No iOS Safari, mostrar/esconder a barra de endereço dispara eventos de
// scroll nativos que competem com nossa simulação de scroll em JS
// (useScrollMomentum) e com o scroll-collapse do header (useHeaderAnimation),
// causando um flicker de layout enquanto os dois sistemas reconciliam a
// posição. Esse composable expõe uma janela de "trégua": enquanto a barra
// do Safari está em transição, os consumidores devem congelar suas
// atualizações de offset/variant até a viewport estabilizar.
const TOOLBAR_TRANSITION_SETTLE_MS = 250;

const isIosToolbarTransitioning = ref(false);
let isListenerAttached = false;
let settleTimeoutId: ReturnType<typeof setTimeout> | null = null;
let lastViewportWidth = 0;

function handleVisualViewportResize(): void {
	const currentWidth = window.visualViewport?.width ?? 0;

	// visualViewport também dispara em resize de janela/orientação no
	// desktop, não só no show/hide da barra do iOS. O toolbar do iOS só
	// altera a altura, então uma mudança de largura é um resize genuíno —
	// nesse caso não tratamos como transição de toolbar.
	if (currentWidth !== lastViewportWidth) {
		lastViewportWidth = currentWidth;
		return;
	}

	isIosToolbarTransitioning.value = true;
	if (settleTimeoutId) clearTimeout(settleTimeoutId);
	settleTimeoutId = setTimeout(() => {
		isIosToolbarTransitioning.value = false;
	}, TOOLBAR_TRANSITION_SETTLE_MS);
}

export function useIosToolbarTransition() {
	if (
		import.meta.client &&
		!isListenerAttached &&
		window.visualViewport &&
		isIOSLikeSafariBrowser({
			userAgent: navigator.userAgent,
			vendor: navigator.vendor,
			platform: navigator.platform,
			maxTouchPoints: navigator.maxTouchPoints
		})
	) {
		lastViewportWidth = window.visualViewport.width;
		window.visualViewport.addEventListener(
			'resize',
			handleVisualViewportResize
		);
		isListenerAttached = true;
	}

	return {
		isIosToolbarTransitioning: readonly(isIosToolbarTransitioning)
	};
}

export function __resetIosToolbarTransitionForTests(): void {
	if (settleTimeoutId) clearTimeout(settleTimeoutId);
	settleTimeoutId = null;
	lastViewportWidth = 0;
	isIosToolbarTransitioning.value = false;

	if (isListenerAttached && typeof window !== 'undefined') {
		window.visualViewport?.removeEventListener(
			'resize',
			handleVisualViewportResize
		);
	}
	isListenerAttached = false;
}
